import { getSaveStatus, onSaveStatusChange } from '../lib/storage.js';
import { isAuthenticated } from '../lib/auth.js';
import { isSupabaseConfigured } from '../lib/supabase.js';

export function renderStatusIndicator() {
  const container = document.getElementById('save-status');
  if (!container) return;

  function update() {
    if (!isSupabaseConfigured() || !isAuthenticated()) {
      container.textContent = '';
      container.className = 'save-status';
      return;
    }

    const status = getSaveStatus();
    container.className = 'save-status save-status-' + status;

    switch (status) {
      case 'saving': container.textContent = 'Syncing...'; break;
      case 'saved':  container.textContent = 'All synced'; break;
      case 'error':  container.textContent = 'Sync error'; break;
      default:       container.textContent = ''; break;
    }
  }

  onSaveStatusChange(update);
  update();
}
